import Home from './Home.vue'
import HomeCLYN from './HomeCLYN.vue'
import MyPoints from './MyPoints.vue'
import ExchangeToDiscount from './ExchangeToDiscount.vue'
import CUSTOMMainAccount from './Account/Main'
import LMGMybranchAccount from './Account/Mybranch'
import CUSTOMMain from './Activity/Main'
import LMGFriendGetFriend from './Activity/FriendGetFriend'
import LMGBvpQuestions from './Activity/BvpQuestions'
import Reward from './Reward/Reward'
import Detail from './Reward/Detail'
import UserAddress from './Reward/UserAddress'
import CUSTOMPromotion from './Promotion/Promotion'
import CUSTOMDetail from './Promotion/Detail'
import CUSTOMAllPromotion from './Promotion/AllPromotion'
import CUSTOMCollecPackage from './Package/CollecPackage'
import CUSTOMMyPackage from './Package/MyPackage'
import CUSTOMBuyPackage from './Package/BuyPackage'

export default {
  Home,
  CUSTOMMain,
  LMGFriendGetFriend,
  LMGBvpQuestions,
  CUSTOMMainAccount,
  LMGMybranchAccount,
  Reward,
  Detail,
  UserAddress,
  MyPoints,
  ExchangeToDiscount,
  CUSTOMPromotion,
  CUSTOMDetail,
  CUSTOMAllPromotion,
  HomeCLYN,
  CUSTOMCollecPackage,
  CUSTOMMyPackage,
  CUSTOMBuyPackage
}



// WEBPACK FOOTER //
// ./src/components/HomeCUSTOM/index.js